import React, { useEffect } from 'react';

import { Box, Button } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { ReactHookFormSelect } from 'common/components/form/bootstrap';
import yupResolver from 'common/utils/yupResolver';

import * as contactFormActions from '../../createContactModal/actions';
import { getUserOptions } from '../../createContactModal/helpers';
import * as contactFormSelectors from '../../createContactModal/selectors';
import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validateReasign';

const ReasignForm = ({
    fetchUsers,
    filterData,
    initialValues,
    openReasignModal,
    save,
    users,
}) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleOnSave = (values) => save(filterData, values);

    return (
        <form onSubmit={handleSubmit(handleOnSave)}>
            <ReactHookFormSelect
                control={control}
                label={t('New installer')}
                name="user"
                options={getUserOptions(users)}
            />

            <Box textAlign="right">
                <Button
                    onClick={() => openReasignModal(false)}
                    sx={{
                        mr: { md: 2, xs: 0 },
                        order: { md: 1, xs: 2 },
                        width: { md: 'auto', xs: '100%' },
                    }}
                    variant="outlined"
                >
                    {t('Cancel')}
                </Button>
                <Button
                    sx={{
                        mb: { md: 0, xs: 2 },
                        order: { md: 2, xs: 1 },
                        width: { md: 'auto', xs: '100%' },
                    }}
                    type="submit"
                    variant="outlined"
                >
                    {t('Save')}
                </Button>
            </Box>
        </form>
    );
};

const mapStateToProps = createStructuredSelector({
    contacts: selectors.getContactsData,
    initialValues: selectors.getReasignInitialValues,
    users: contactFormSelectors.getUsersData,
});

const mapDispatchToProps = (dispatch) => ({
    fetchUsers: () => dispatch(contactFormActions.fetchUsers()),
    openReasignModal: (value) => dispatch(actions.openReasignModal(value)),
    save: (filterData, values) =>
        dispatch(actions.bulkReasignItems(filterData, values)),
});

ReasignForm.propTypes = {
    fetchUsers: PropTypes.func,
    filterData: PropTypes.object,
    initialValues: PropTypes.object,
    openReasignModal: PropTypes.func,
    save: PropTypes.func,
    users: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReasignForm);
